//-MixItUp filter Activities
if ($('.activities').length) {
  let mixer = mixitup('.mix-container', {
    controls: {
      toggleLogic: 'or'
    },
    animation: {
      effectsIn: 'fade translateY(100px)',
      effectsOut: 'fade translateY(-100px)'
    }
  });
}